import React from "react";
import "./About.css";

export default function About() {
  return (
    <div id="about">
      <h1>How it Works</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada eros ligula, vel fermentum tellus
        mattis vel. Quisque semper erat molestie velit accumsan, in scelerisque massa molestie. Pellentesque orci ante,
        porttitor eget congue tristique, mattis sed magna. Mauris fermentum dapibus dui non congue. Suspendisse
        ullamcorper tellus nulla, eu feugiat dui dictum sed. Orci varius natoque penatibus et magnis dis parturient
        montes, nascetur ridiculus mus. Integer laoreet, ipsum at rhoncus auctor, neque dui mattis sapien, at malesuada
        ante ante et dolor. Proin eget nibh scelerisque, vestibulum ipsum ac, accumsan lacus. Nulla ex lorem, malesuada
        in imperdiet finibus, molestie quis lectus. Morbi porta suscipit velit, in ullamcorper quam luctus vitae.
      </p>
    </div>
  );
}
